import { all, takeEvery, put, fork, call } from "redux-saga/effects";
import LockedlistService from "../../services/LockedService";
import { LOCKED_LIST_LOADDATA } from "redux/constants/LockedListConst";
import { success } from "redux/actions/lockedListActions";

export function* loaddata() {
  yield takeEvery(LOCKED_LIST_LOADDATA, function* (payload) {
    try {
      const res = yield call(LockedlistService.getAll, payload);
      console.log("Saga success");
      yield put(success(res.data.data.data));
    } catch (err) {
      console.log("saga error");
      console.log(err);
    }
  });
}

export default function* rootSaga() {
  yield all([fork(loaddata)]);
}
